export const unauthorizedPageUrl = '/auth/unauthorized';

export const baseURI = API_URL;